"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedPartnerSchema = void 0;
exports.FeaturedPartnerSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/featured-partners.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FeaturedPartner",
    "description": "Represents the premium partners associated with the resource",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "const": "attributes:featured-partners"
        },
        "caption": {
            "type": "string",
            "description": "The optional caption for the featured partners (e.g.: \"Powered by\", \"Sponsored by\", \"In cooperation with\")"
        },
        "partners": {
            "description": "The featured partners associated with the resource",
            "type": "array",
            "items": {
                "oneOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                    }
                ]
            },
            "minItems": 1
        }
    },
    "required": [
        "partners",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZWQtcGFydG5lcnMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9mZWF0dXJlZC1wYXJ0bmVycy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxxQkFBcUIsR0FBRztJQUNuQyxLQUFLLEVBQUUsMEVBQTBFO0lBQ2pGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGlCQUFpQjtJQUMxQixhQUFhLEVBQUUsOERBQThEO0lBQzdFLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sT0FBTyxFQUFFLDhCQUE4QjtTQUN4QztRQUNELFNBQVMsRUFBRTtZQUNULE1BQU0sRUFBRSxRQUFRO1lBQ2hCLGFBQWEsRUFBRSxrSEFBa0g7U0FDbEk7UUFDRCxVQUFVLEVBQUU7WUFDVixhQUFhLEVBQUUsb0RBQW9EO1lBQ25FLE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE9BQU8sRUFBRTtvQkFDUDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsTUFBTSxFQUFFLGdGQUFnRjtxQkFDekY7aUJBQ0Y7YUFDRjtZQUNELFVBQVUsRUFBRSxDQUFDO1NBQ2Q7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFVBQVU7UUFDVixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=